import { apiRequest } from "./tenantUserAdminService";

export async function queryAssistant(tenantId, { task, contextFilters, sessionId } = {}) {
  if (!tenantId) throw new Error("tenantId required");
  const path = `/tenant/${encodeURIComponent(tenantId)}/assistant/query`;
  return apiRequest(path, { method: "POST", body: { task, contextFilters, sessionId } });
}

export async function executeAssistant(tenantId, { requestId, action, executeMode = "dry" } = {}) {
  if (!tenantId) throw new Error("tenantId required");
  const path = `/tenant/${encodeURIComponent(tenantId)}/assistant/execute`;
  return apiRequest(path, { method: "POST", body: { requestId, action, executeMode } });
}

export default { queryAssistant, executeAssistant };

